<script>
import { mapState } from "vuex"

export default {
  props: { ativar: Boolean },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      email: state => state.moduleEmail.email,
    }),
  },
  methods:{
    btnSalvarAlterar() {
      this.$store.dispatch("ALTERAREMAIL", {
          codOcorrencia: this.email.codOcorrencia,
          usuario: this.usuario.codUsuario,
          cidade: this.user.cidade,
          email: this.email
      }).then((result) => {
        if(result){
          this.$swal.fire({
            title: "Alterar o Email",
            text: 'Gravado com Sucesso',
            icon: "success"
          })
          this.$emit('limparCampos')
        }
        else{
          this.$swal.fire({
            title: "Alterar o Email",
            text: 'Erro na Tentativa de Alterar o email',
            icon: "error"
          })
        }
        }
      )
    },
  }
    
}
</script>

<template>
  <b-button :disabled='!email.placaValido && !email.placaCompleta' @click='btnSalvarAlterar' :variant="!ativar ? 'warning' : ''">Alterar</b-button>
</template>

<style>

</style>